import React from 'react';
import PropTypes from 'prop-types';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import RenderTextField from '../common/RenderTextField';
import { validateRequiredWithAsyncValidationEmail } from '../../utils/validators';
import PasswordSettingsForm from './PasswordSettingsForm';
import { InputAdornment, Button, Box, TextField } from '@mui/material';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import { Field, Form, Formik, FastField } from 'formik';

// TODO check validaton
const UserSettingsForm = ({ onSubmit, initialValues }) => {
  const showAsterisks = true;
  const alreadyApplied = false;
  const initialEmail = initialValues?.email || '';

  return (
       <Box
                           sx={{
                             maxWidth: 400,
                             mx: 'auto',
                             p: 3,
                             borderRadius: 2,
                             display: 'flex',
                             flexDirection: 'column',
                           }}
                         >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={onSubmit}
            validateOnChange={true}
            validateOnBlur={true}
      >
        {({ isSubmitting, handleSubmit, dirty }) => (
          <Form onSubmit={handleSubmit}>

         <Field
                                 InputProps={{
                                   startAdornment: (
                                     <InputAdornment position="start">
                                       <EmailOutlined />
                                     </InputAdornment>
                                   ),
                                 }}
            showAsterisk={showAsterisks}
            disabled={alreadyApplied}
            name="email"
            label="Email"
            as={TextField}
            type="text"
            fullWidth
            margin="normal"
              variant="outlined"
            validate={validateRequiredWithAsyncValidationEmail(initialEmail)} />

           <Box sx={{ mt: 2 }}>
              <Button
                    color="primary"
                            variant="contained"
                            fullWidth
                            type="submit"
                            disabled={isSubmitting || !dirty}
              >
                Zapisz
              </Button>
              </Box>

          </Form>
        )}
      </Formik>
      <PasswordSettingsForm />
       </Box>
  );
};

UserSettingsForm.propTypes = {
  onSubmit: PropTypes.func,
  initialValues: PropTypes.object,
};

export default UserSettingsForm;
